var map = {
	"./search-results-page.de-CH.json": 1252,
	"./search-results-page.de-DE.json": 1253,
	"./search-results-page.en-CA.json": 1254,
	"./search-results-page.en-GB.json": 1255,
	"./search-results-page.en-IN.json": 1256,
	"./search-results-page.en-ME.json": 1257,
	"./search-results-page.en-US.json": 1258,
	"./search-results-page.es-EM.json": 1259,
	"./search-results-page.es-ES.json": 1260,
	"./search-results-page.fr-BE.json": 1261,
	"./search-results-page.fr-CA.json": 1262,
	"./search-results-page.fr-CH.json": 1263,
	"./search-results-page.nl-BE.json": 1264,
	"./search-results-page.nl-NL.json": 1265,
	"./search-results-page.pl-PL.json": 1266,
	"./search-results-page.pt-BR.json": 1267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1251;